import { render, staticRenderFns } from "./course-transport.vue?vue&type=template&id=adb84580&scoped=true&"
import script from "./course-transport.vue?vue&type=script&lang=js&"
export * from "./course-transport.vue?vue&type=script&lang=js&"
import style0 from "./course-transport.vue?vue&type=style&index=0&id=adb84580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb84580",
  null
  
)

export default component.exports